"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionTraceFilterSchema = exports.sessionTraceFilterColumns = void 0;
const zod_1 = require("zod");
const filters_1 = require("../../interfaces/filters");
exports.sessionTraceFilterColumns = [
    {
        id: "isRootObservation",
        name: "Root observation",
        type: "boolean",
        internal: "is_root_observation",
    },
    { id: "traceName", name: "Trace name", type: "string", internal: "name" },
    { id: "userId", name: "User ID", type: "string", internal: "user_id" },
    {
        id: "environment",
        name: "Environment",
        type: "string",
        internal: "environment",
    },
    {
        id: "traceTags",
        name: "Trace tags",
        type: "arrayOptions",
        internal: "tags",
        options: [],
    },
    {
        id: "name",
        name: "Observation name",
        type: "string",
        internal: "name",
    },
    {
        id: "type",
        name: "Observation type",
        type: "string",
        internal: "type",
    },
    {
        id: "level",
        name: "Observation level",
        type: "string",
        internal: "level",
    },
    {
        id: "metadata",
        name: "Observation metadata",
        type: "stringObject",
        internal: "metadata",
    },
];
// Saved views and shared URLs created before observation filtering used root fields.
const legacyObservationColumns = {
    rootName: "name",
    rootType: "type",
    rootLevel: "level",
    rootMetadata: "metadata",
};
exports.sessionTraceFilterSchema = filters_1.singleFilterList
    .transform((filters) => filters.map((filter) => ({
    ...filter,
    column: legacyObservationColumns[filter.column] ?? filter.column,
})))
    .pipe(zod_1.z.array(zod_1.z.discriminatedUnion("type", [
    filters_1.booleanFilter.extend({ column: zod_1.z.literal("isRootObservation") }),
    filters_1.stringOptionsFilter.extend({ column: zod_1.z.enum(["name", "traceName"]) }),
    filters_1.stringFilter.extend({
        column: zod_1.z.enum([
            "traceName",
            "userId",
            "environment",
            "name",
            "type",
            "level",
        ]),
    }),
    filters_1.arrayOptionsFilter.safeExtend({ column: zod_1.z.literal("traceTags") }),
    filters_1.stringObjectFilter.extend({ column: zod_1.z.literal("metadata") }),
])));
